var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Inject } from "../../di/inject";
import { DOMUtils } from "../dom/index";
var Form = /** @class */ (function () {
    function Form(submitButton) {
        var builders = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            builders[_i - 1] = arguments[_i];
        }
        this.submitButton = submitButton;
        this._isValid = true;
        this._builders = [];
        this.builders = builders || [];
        this.addEventListeners();
    }
    Object.defineProperty(Form.prototype, "isValid", {
        get: function () {
            return this._isValid;
        },
        set: function (value) {
            this._isValid = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Form.prototype, "builders", {
        get: function () {
            return this._builders;
        },
        set: function (value) {
            this._builders = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Form.prototype, "onSubmission", {
        get: function () {
            return this._onSubmission;
        },
        set: function (value) {
            this._onSubmission = value;
        },
        enumerable: false,
        configurable: true
    });
    Form.prototype.addEventListeners = function () {
        var _this = this;
        var _a;
        if ((_a = this.submitButton) === null || _a === void 0 ? void 0 : _a.form) {
            this.submitButton.form.addEventListener('submit', this.onSubmit.bind(this));
        }
        this.builders.forEach(function (builder) {
            _this.domUtils.addEventListener(builder.field, 'keyup,input', _this.validate.bind(_this));
        });
    };
    Form.prototype.onSubmit = function (e) {
        this.validate();
        if (!this.isValid) {
            e.preventDefault();
        }
        this.onSubmission && this.onSubmission(e);
    };
    Form.prototype.validate = function () {
        this.isValid = this.builders.every(function (builder) { return builder.validate(); });
        if (!this.isValid) {
            this.submitButton.setAttribute('disabled', 'disabled');
        }
        else {
            this.submitButton.removeAttribute('disabled');
        }
        return this;
    };
    __decorate([
        Inject(),
        __metadata("design:type", DOMUtils)
    ], Form.prototype, "domUtils", void 0);
    return Form;
}());
export { Form };
//# sourceMappingURL=index.js.map